// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"79ba1728","207":"f16302bc","209":"35448ce8","355":"2626cc3e","357":"9458192d","585":"05a85c91","604":"1d8f76d3","610":"a2084f9b","787":"3e99342f","808":"f27ffbc6","963":"a34a7242","968":"062b0d9a"}[chunkId] + ".chunk.js";
};